package network

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.first

/**
 * Singleton que cachea la configuración de pagos para acceso rápido.
 * Se carga al inicio desde Firebase config/.
 */
object ConfigPagos {
    // Default false hasta confirmar por fetch: si el admin apagó Stripe en config remoto,
    // no queremos que el cliente asuma activo y falle en CF cuando en realidad debe ir manual.
    private val _stripeActivo = MutableStateFlow(false)
    val stripeActivo: StateFlow<Boolean> = _stripeActivo.asStateFlow()

    private val _clabeManual = MutableStateFlow("")
    val clabeManual: StateFlow<String> = _clabeManual.asStateFlow()

    private val _beneficiarioManual = MutableStateFlow("")
    val beneficiarioManual: StateFlow<String> = _beneficiarioManual.asStateFlow()

    private val _bancoManual = MutableStateFlow("")
    val bancoManual: StateFlow<String> = _bancoManual.asStateFlow()

    private val _telefonoAtencion = MutableStateFlow("")
    val telefonoAtencion: StateFlow<String> = _telefonoAtencion.asStateFlow()

    private val _cargado = MutableStateFlow(false)
    val cargado: StateFlow<Boolean> = _cargado.asStateFlow()

    private fun aplicar(snap: dev.gitlive.firebase.database.DataSnapshot) {
        if (snap.exists) {
            _stripeActivo.value = try { snap.child("stripeActivo").value<Boolean>() } catch (_: Exception) { true }
            _clabeManual.value = try { snap.child("clabeManual").value<String>() } catch (_: Exception) { "" }
            _beneficiarioManual.value = try { snap.child("beneficiarioManual").value<String>() } catch (_: Exception) { "" }
            _bancoManual.value = try { snap.child("bancoManual").value<String>() } catch (_: Exception) { "" }
            _telefonoAtencion.value = try { snap.child("telefonoAtencion").value<String>() } catch (_: Exception) { "" }
        }
    }

    /** Carga inicial (una vez) — usada para no avanzar el arranque sin la config. */
    suspend fun cargar() {
        try {
            val snap = FirebaseClient.database.reference("config").valueEvents.first()
            aplicar(snap)
        } catch (_: Exception) {}
        _cargado.value = true
    }

    /** Escucha continua: cualquier cambio en config/ (ej. apagar Stripe) se refleja en TODAS
     *  las plataformas en tiempo real. Suspende indefinidamente — lanzar en su propia corrutina. */
    suspend fun escuchar() {
        try {
            FirebaseClient.database.reference("config").valueEvents.collect { snap ->
                aplicar(snap)
                _cargado.value = true
            }
        } catch (_: Exception) {}
    }

    /** Sincroniza solo el flag de Stripe tras releerlo del servidor (verificación de guardado). */
    fun actualizarStripeActivo(activo: Boolean) { _stripeActivo.value = activo }

    fun actualizar(stripeActivo: Boolean, clabe: String, beneficiario: String, banco: String, telefono: String) {
        _stripeActivo.value = stripeActivo
        _clabeManual.value = clabe
        _beneficiarioManual.value = beneficiario
        _bancoManual.value = banco
        _telefonoAtencion.value = telefono
    }
}
